import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Box, makeStyles, Hidden, IconButton, Button, Link } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import FacebookIcon from '@material-ui/icons/Facebook';
import YouTubeIcon from '@material-ui/icons/YouTube';
import PhoneIcon from '@material-ui/icons/Phone';
import CloudIcon from '@material-ui/icons/Cloud';

import Logo from '/components/layouts/Logo';
import SearchInput from '/components/shared/SearchInput';
import Navbar from 'components/shared/Navbar';

// utils
import useWindowSize from '/utils/useWindowSize';

import HeadImage from '/public/home/headImg.png';

const useStyles = makeStyles({
    root: {
        backgroundColor: 'white',
        justifyContent: 'flex-end',
        alignItems: 'center',
        boxShadow: '0px 3px 6px #0000000d',
    },
    rootFixed: {
        marginBottom: 60,
    },
    head: {
        width: '100%',
        height: 118,
        display: 'flex',
        backgroundImage: `url(${HeadImage.src})`,
        backgroundSize: 'cover',
    },
    items: {
        width: 1000,
        display: 'flex',
        justifyContent: 'space-between',
        margin: 'auto',
    },
    toolbar: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        minHeight: 48,
    },
    menuRoot: {
        width: '100%',
        margin: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'white',
        height: 60,
        zIndex: 1000,
    },
    menuRootFixed: {
        top: 0,
        position: 'fixed',
        boxShadow: '1px 3px 6px #0000000d',
    },
    menu: {
        display: 'flex',
        width: 1000,
        alignItems: 'center',
    },
    menuText: {
        color: '#7c7c7c',
        padding: '26px 12px',
        cursor: 'pointer',
    },
    boxCss: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        margin: 'auto',
    },
    headIcons: {
        marginLeft: 10,
        opacity: 0.8,
        cursor: 'pointer',
        color: 'white',
    },
    lang: {
        color: 'white',
        minWidth: 40,
    },
    SearchInput: {
        border: '1px solid gray',
    },
});

const TopBar = ({ className, onMobileNavOpen, menus, ...rest }) => {
    const classes = useStyles();
    const { width } = useWindowSize();
    const [scrollTop, setScrollTop] = useState(0);

    const onScroll = (e) => {
        setScrollTop(e.target.documentElement.scrollTop);
    };

    useEffect(() => {
        window.addEventListener('scroll', onScroll);
    }, []);

    const menuStyle = clsx({
        [classes.menuRoot]: true, //always applies
        [classes.menuRootFixed]: scrollTop > 110, //only when open === true
    });

    const rootStyle = clsx({
        [classes.root]: true, //always applies
        [classes.rootFixed]: scrollTop > 110, //only when open === true
    });

    return (
        <Box className={rootStyle}>
            <Box className={classes.head}>
                <Box className={classes.items}>
                    <Logo />
                    {width > 500 ? (
                        <Box style={{ alignContent: 'space-between', display: 'grid' }}>
                            <Box style={{ display: 'flex', justifyContent: 'end' }}>
                                <Button className={classes.lang} variant="text">
                                    <PhoneIcon
                                        style={{ width: 16, marginRight: 8 }}
                                        className={classes.headIcons}
                                    />
                                    Утас: 70345339
                                </Button>
                            </Box>
                            <Box style={{ justifyContent: 'end', display: 'flex' }}>
                                <Link href={`https://www.facebook.com/teshigzdtg`} target="_blank">
                                    <FacebookIcon className={classes.headIcons} />
                                </Link>
                                <Link
                                    href={`https://www.youtube.com/watch?v=FYVCCpW6yx0`}
                                    target="_blank"
                                >
                                    <YouTubeIcon className={classes.headIcons} />
                                </Link>
                                <Link
                                    href={`http://bulgan.tsag-agaar.gov.mn/forecast/forecast5days?fbclid=IwAR3DT17tACwFHGfaDFYktNP6afPFjC7ivXBS-bZxhQJSIW_ZvJ4FjXHtKUc`}
                                    target="_blank"
                                >
                                    <CloudIcon className={classes.headIcons} />
                                </Link>
                            </Box>
                        </Box>
                    ) : (
                        <Box>
                            <Hidden lgUp>
                                <IconButton color="white" onClick={onMobileNavOpen}>
                                    <MenuIcon
                                        color="white"
                                        fontSize="large"
                                        style={{ color: 'white' }}
                                    />
                                </IconButton>
                            </Hidden>
                        </Box>
                    )}
                </Box>
            </Box>
            {width > 500 && (
                <Box className={menuStyle}>
                    <Box className={classes.menu}>
                        <Navbar menus={menus} />
                    </Box>
                </Box>
            )}
        </Box>
    );
};

TopBar.propTypes = {
    className: PropTypes.string,
    onMobileNavOpen: PropTypes.func,
    menus: PropTypes.array,
};

TopBar.defaultProps = {
    menus: [],
};

export default TopBar;
